<template lang='pug'>
div
    transition-group(v-if="options.length>1"
        appear,
        appear-class='custom-appear-class',
        appear-to-class='custom-appear-to-class',
        appear-active-class='custom-appear-active-class')
        .item(
            v-for='item in options',
            :key='item.text',
            v-src='item.img',
            @click='itemClick(item)'
        )
            .row {{ item.text }}
    transition(v-else
        appear,
        appear-class='custom-appear-class',
        appear-to-class='custom-appear-to-class',
        appear-active-class='custom-appear-active-class')
        .item(
            v-src='options[0].img',
            @click='itemClick(options[0])'
        )
            .row {{ options[0].text }}
</template>

<script>
export default {
    props: {
        options: {
            type: Array,
            default() {
                return []
            }
        }
    },
    methods: {
        itemClick(item) {
            if (item.to) {
                this.$router.push(item.to)
            }
        }
    }
}
</script>

<style scoped lang='less'>
.item {
    width: 100%;
    height: 8.75rem;
    background: transparent no-repeat center/cover;
    display: flex;
    align-items: flex-end;
    &:not(:last-child) {
        margin-bottom: 1.2rem;
    }
    .row {
        background: linear-gradient(135deg, #7abac9 92%, #fff 92%);
        text-align: center;
        color: #fff;
        font-size: 0.8rem;
        width: 100%;
        line-height: 2.1rem;
        position: relative;
        &::after {
            content: '';
            background: url('~@/assets/imgs/arrow.png') no-repeat center/contain;
            width: 0.6rem;
            height: 0.6rem;
            position: absolute;
            right: 0.2rem;
            bottom: 0.2rem;
        }
    }
}
.custom-appear-class {
    transform: translateX(125%);
    .row {
        opacity: 0;
        transform: translateX(-225%);
    }
}
.custom-appear-to-class {
    .row {
        opacity: 1;
    }
}
.custom-appear-active-class {
    transition: all 0.5s ease-in;
    .row {
        transition: all 0.5s ease-in;
    }
}
</style>